import {
  CHILDRENBOOK,
  SIGN_OUT,
} from '../actions/constants';

const initialState = {
  handling: false,
  data: {},
};

export default function childrenBook(state = initialState, action) {
  switch (action.type) {
    case CHILDRENBOOK.handlers.fetch:
    case CHILDRENBOOK.handlers.update:
    case CHILDRENBOOK.handlers.remove:
      return {
        ...state,
        handling: true,
      };
    case CHILDRENBOOK.update:
      return {
        ...state,
        data: action.merge ? {
          ...state.data,
          ...action.data,
        } : action.data,
        handling: false,
      };
    case SIGN_OUT:
      return initialState;
    default:
      return state;
  }
}
